import PageContainer from "../components/PageContainer";

const ImageDisclaimer = () => {
    return (
        <PageContainer items="center" px="4">
            <div className="flex flex-col gap-8 max-w-[600px] mt-8 terms">
                <h3 className="font-normal">Disclaimer immagini</h3>
                <div>
                    <p>
                        Le immagini presenti su questo sito web sono protette da copyright e sono di proprietà di TicinoWild o
                        dei rispettivi autori, ove indicato. È vietata la riproduzione, distribuzione o modifica delle immagini
                        senza il consenso esplicito dei titolari dei diritti.
                    </p>
                    <p>
                        In caso di immagini di terze parti, abbiamo ottenuto le necessarie autorizzazioni per il loro utilizzo. Se
                        ritenete che una delle immagini violi i vostri diritti, vi invitiamo a contattarci all’indirizzo
                        info@ticinowild.ch per procedere a una revisione tempestiva.
                    </p>
                    <p>
                        Nessun tasso reale è stato maltrattato o coinvolto per la realizzazione delle immagini presenti su
                        questo sito web. Tutte le immagini del tasso sono state create usando l’intelligenza artificiale.
                    </p>
                    <p>
                        Le immagini dei prodotti presenti nello shop sono a puro scopo illustrativo; potrebbero differire
                        leggermente dal prodotto effettivo.
                    </p>
                    <p>
                        Le immagini di luoghi o attività collegate ad una o più schede di attività sono immagini reali, non
                        manipolate o generate con l’intelligenza artificiale. Queste immagini rappresentano un preciso
                        momento nel tempo e sono a puro scopo illustrativo; la realtà potrebbe differire a causa di fattori
                        indipendenti da TicinoWild.
                    </p>
                    <p>
                        TicinoWild si impegna, nel limite del possibile, a mantenere aggiornate tutte le informazioni e
                        immagini illustrative presenti sul suo sito web. Se siete a conoscenza di cambiamenti importanti legati
                        ad un luogo o attività vi invitiamo a segnalarcelo scrivendo all’indirizzo info@ticinowild.ch.
                    </p>
                </div>
            </div>
        </PageContainer>
    )
}

export default ImageDisclaimer